import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { clearAuth, setTokens } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        setUser(null);
      }
    }
    setLoading(false);
  }, []);

  const login = useCallback((data) => {
    // data shape from backend: { user, tokens }
    const { user: u, tokens } = data || {};
    if (tokens) setTokens(tokens);
    if (u) {
      localStorage.setItem("user", JSON.stringify(u));
      localStorage.setItem("isLoggedIn", "true");
      setUser(u);
    }
  }, []);

  const logout = useCallback(async () => {
    try {
      const { authApi } = await import("../api/client");
      await authApi.logout();
    } catch (err) {
      // Continue with logout even if API call fails
    } finally {
      clearAuth();
      setUser(null);
    }
  }, []);

  const value = useMemo(
    () => ({
      user,
      role: user?.role || null,
      isAuthenticated: Boolean(user),
      loading,
      login,
      logout,
      setUser,
    }),
    [user, loading, login, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
